import { AuthSource } from '@framework/auth';
import { IFrontLoginFormProps } from '@framework/theme/src/front/FrontLoginForm';
import { LoaderSpin, LoginCard } from '@framework/ui';
import { CommonLoginForm } from '../auth/CommonLoginForm';
import { SoapLoginForm } from '../front/soap-ldap/SoapLoginForm';

/**
 * Form di login all'applicativo per la parte Admin
 */
export function AdminLoginForm(props: IFrontLoginFormProps) {
  const { loading = false, resolvePublicUrl, onLogin, externalLogin } = props;

  return (
    <LoaderSpin spinning={loading} transparent>
      <LoginCard title="Login">
        <CommonLoginForm
          hideOpenWeb
          resolvePublicUrl={resolvePublicUrl}
          // Per il momento escludiamo l'accesso per gli utenti esterni
          // externalLogin={externalLogin}
        />
        <SoapLoginForm source={AuthSource.Admin} onLogin={onLogin} />
      </LoginCard>
    </LoaderSpin>
  );
}
